"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M8.507 9.928l3.31-3.328v10.8l-3.31-3.328H7.076A1.08 1.08 0 016 12.985v-1.97c0-.6.481-1.087 1.076-1.087h1.43zM13.2 15V9c1.245.555 2.1 1.69 2.1 3s-.854 2.445-2.1 3z" }), "Normal");
//# sourceMappingURL=VolumeNormal.js.map